<section class="echosys-second" id="map_id">
  <div class="container-fluid">
    <div class="mb-3 mt-5">
      <h1 class="text-center new-title">Our Ecosystem</h1>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="map_div">
          <div class="map_section_dev">
            <div class="hover-switch" id="Thiruvallur">
              <img
                src="assets/images/new-map/blue/Thiruvallur.png"
                class="Thiruvallur"
                alt="Thiruvallur"
              />
              <img
                src="assets/images/new-map/new_yellow/Thiruvallur.png"
                class="Thiruvallur2"
                data-toggle="tooltip"
                data-placement="top"
                title="Thiruvallur"
                (click)="mapGetBtn('Thiruvallur')"
                alt=""
              />
            </div>
            <div class="hover-switch" id="Chennai">
              <img
                src="assets/images/new-map/blue/Chennai.png"
                class="Chennai"
              />
              <img
                src="assets/images/new-map/new_yellow/Chennai.png"
                class="Chennai2"
                alt="Chennai"
                data-toggle="tooltip"
                data-placement="top"
                title="Chennai"
                (click)="mapGetBtn('Chennai')"
              />
            </div>
            <div class="hover-switch" id="Vellore">
              <img
                src="assets/images/new-map/blue/Vellore.png"
                class="Vellore"
              />
              <img
                src="assets/images/new-map/new_yellow/Vellore.png"
                class="Vellore2"
                alt="Vellore"
                data-toggle="tooltip"
                data-placement="top"
                title="Vellore"
                (click)="mapGetBtn('Vellore')"
              />
            </div>
            <div class="hover-switch" id="Ranipet">
              <img
                src="assets/images/new-map/blue/Ranipet.png"
                class="Ranipet"
                alt="Ranipet"
              />
              <img
                src="assets/images/new-map/new_yellow/Ranipet.png"
                class="Ranipet2"
                alt="Ranipet"
                data-toggle="tooltip"
                data-placement="top"
                title="Ranipet"
                (click)="mapGetBtn('Ranipet')"
              />
            </div>
            <div class="hover-switch" id="Kanchipuram">
              <img
                src="assets/images/new-map/blue/Kanchipuram.png"
                class="Kanchipuram"
                alt="Kanchipuram"
              />
              <img
                src="assets/images/new-map/new_yellow/Kanchipuram.png"
                class="Kanchipuram2"
                alt="Kanchipuram"
                data-toggle="tooltip"
                data-placement="top"
                title="Kanchipuram"
                (click)="mapGetBtn('Kanchipuram')"
              />
            </div>
            <div class="hover-switch" id="Chengalpattu">
              <img
                src="assets/images/new-map/blue/Chengalpattu.png"
                class="Chengalpattu"
                alt="Chengalpattu"
              />
              <img
                src="assets/images/new-map/new_yellow/Chengalpattu.png"
                class="Chengalpattu2"
                alt="Chengalpattu"
                data-toggle="tooltip"
                data-placement="top"
                title="Chengalpattu"
                (click)="mapGetBtn('Chengalpattu')"
              />
            </div>
            <div class="hover-switch" id="Tirupatur">
              <img
                src="assets/images/new-map/blue/Thirupathur.png"
                class="Tirupatur"
                alt="Tirupatur"
              />
              <img
                src="assets/images/new-map/new_yellow/Thirupathur.png"
                class="Tirupatur2"
                alt="Tirupatur"
                data-toggle="tooltip"
                data-placement="top"
                title="Tirupatur"
                (click)="mapGetBtn('Tirupatur')"
              />
            </div>
            <div class="hover-switch" id="Tiruvannamalai">
              <img
                src="assets/images/new-map/blue/Thiruvannamalai.png"
                class="Tiruvannamalai"
                alt="Tiruvannamalai"
              />
              <img
                src="assets/images/new-map/new_yellow/Thiruvannamalai.png"
                class="Tiruvannamalai2"
                alt="Tiruvannamalai"
                data-toggle="tooltip"
                data-placement="top"
                title="Tiruvannamalai"
                (click)="mapGetBtn('Tiruvannamalai')"
              />
            </div>
            <div class="hover-switch" id="Villupuram">
              <img
                src="assets/images/new-map/blue/Villupuram.png"
                class="Villupuram"
                alt="Villupuram"
              />
              <img
                src="assets/images/new-map/new_yellow/Vilupuram.png"
                class="Villupuram2"
                alt="Villupuram"
                data-toggle="tooltip"
                data-placement="top"
                title="Villupuram"
                (click)="mapGetBtn('Villupuram')"
              />
            </div>
            <div class="hover-switch" id="Krishnagiri">
              <img
                src="assets/images/new-map/blue/Krishnagiri.png"
                class="Krishnagiri"
                alt="Krishnagiri"
              />
              <img
                src="assets/images/new-map/new_yellow/Krishnagiri.png"
                class="Krishnagiri2"
                alt="Krishnagiri"
                data-toggle="tooltip"
                data-placement="top"
                title="Krishnagiri"
                (click)="mapGetBtn('Krishnagiri')"
              />
            </div>
            <div class="hover-switch" id="Dharmapuri">
              <img
                src="assets/images/new-map/blue/Dharmapuri.png"
                class="Dharmapuri"
                alt="Dharmapuri"
              />
              <img
                src="assets/images/new-map/new_yellow/Dharmapuri.png"
                class="Dharmapuri2"
                alt="Dharmapuri"
                data-toggle="tooltip"
                data-placement="top"
                title="Dharmapuri"
                (click)="mapGetBtn('Dharmapuri')"
              />
            </div>
            <div class="hover-switch" id="Cuddalore">
              <img
                src="assets/images/new-map/blue/Cuddalore.png"
                class="Cuddalore"
                alt="Cuddalore"
              />
              <img
                src="assets/images/new-map/new_yellow/Cuddalore.png"
                class="Cuddalore2"
                alt="Cuddalore"
                data-toggle="tooltip"
                data-placement="top"
                title="Cuddalore"
                (click)="mapGetBtn('Cuddalore')"
              />
            </div>
            <div class="hover-switch" id="Kallakurichi">
              <img
                src="assets/images/new-map/blue/Kallakuruchi.png"
                class="Kallakurichi"
                alt="Kallakurichi"
              />
              <img
                src="assets/images/new-map/new_yellow/kallakurichi.png"
                class="Kallakurichi2"
                alt="Kallakurichi"
                data-toggle="tooltip"
                data-placement="top"
                title="Kallakurichi"
                (click)="mapGetBtn('Kallakurichi')"
              />
            </div>
            <div class="hover-switch" id="Salem">
              <img
                src="assets/images/new-map/blue/Salem.png"
                class="Salem"
                alt="Salem"
              />
              <img
                src="assets/images/new-map/new_yellow/Salem.png"
                class="Salem2"
                alt="Salem"
                data-toggle="tooltip"
                data-placement="top"
                title="Salem"
                (click)="mapGetBtn('Salem')"
              />
            </div>
            <div class="hover-switch" id="Erode">
              <img
                src="assets/images/new-map/blue/Erode.png"
                class="Erode"
                alt="Erode"
              />
              <img
                src="assets/images/new-map/new_yellow/Erode.png"
                class="Erode2"
                alt="Erode"
                data-toggle="tooltip"
                data-placement="top"
                title="Erode"
                (click)="mapGetBtn('Erode')"
              />
            </div>
            <div class="hover-switch" id="Namakkal">
              <img
                src="assets/images/new-map/blue/Namakkal.png"
                class="Namakkal"
                alt="Namakkal"
              />
              <img
                src="assets/images/new-map/new_yellow/Namakkal.png"
                class="Namakkal2"
                alt="Namakkal"
                data-toggle="tooltip"
                data-placement="top"
                title="Namakkal"
                (click)="mapGetBtn('Namakkal')"
              />
            </div>
            <div class="hover-switch" id="Perambalur">
              <img
                src="assets/images/new-map/blue/Perambalur.png"
                class="Perambalur"
                alt="Perambalur"
              />
              <img
                src="assets/images/new-map/new_yellow/Perambalur.png"
                class="Perambalur2"
                alt="Perambalur"
                data-toggle="tooltip"
                data-placement="top"
                title="Perambalur"
                (click)="mapGetBtn('Perambalur')"
              />
            </div>
            <div class="hover-switch" id="Ariyalur">
              <img
                src="assets/images/new-map/blue/Ariyalur.png"
                class="Ariyalur"
                alt="Ariyalur"
              />
              <img
                src="assets/images/new-map/new_yellow/Ariyalur.png"
                class="Ariyalur2"
                alt="Ariyalur"
                data-toggle="tooltip"
                data-placement="top"
                title="Ariyalur"
                (click)="mapGetBtn('Ariyalur')"
              />
            </div>
            <div class="hover-switch" id="Mayiladuthurai">
              <img
                src="assets/images/new-map/blue/Mayiladuthurai.png"
                class="Mayiladuthurai"
                alt="Mayiladuthurai"
              />
              <img
                src="assets/images/new-map/new_yellow/Mayiladuthurai.png"
                class="Mayiladuthurai"
                alt="Mayiladuthurai"
                data-toggle="tooltip"
                data-placement="top"
                title="Mayiladuthurai"
                (click)="mapGetBtn('Mayiladuthurai')"
              />
            </div>
            <div class="hover-switch" id="Thiruvarur">
              <img
                src="assets/images/new-map/blue/Thiruvarur.png"
                class="Thiruvarur"
                alt="Thiruvarur"
              />
              <img
                src="assets/images/new-map/new_yellow/Thiruvatur.png"
                class="Thiruvarur2"
                alt="Thiruvarur"
                data-toggle="tooltip"
                data-placement="top"
                title="Thiruvarur"
                (click)="mapGetBtn('Thiruvarur')"
              />
            </div>
            <div class="hover-switch" id="Nagapattinam">
              <img
                src="assets/images/new-map/blue/Nagaattinam.png"
                class="Nagapattinam"
                alt="Nagapattinam"
              />
              <img
                src="assets/images/new-map/new_yellow/Nagapattinam.png"
                class="Nagapattinam2"
                alt="Nagapattinam"
                data-toggle="tooltip"
                data-placement="top"
                title="Nagapattinam"
                (click)="mapGetBtn('Nagapattinam')"
              />
            </div>
            <div class="hover-switch" id="Tiruchirappalli">
              <img
                src="assets/images/new-map/blue/Thiruchurapalli.png"
                class="Tiruchurapalli"
                alt="Tiruchurapalli"
              />
              <img
                src="assets/images/new-map/new_yellow/Thiruchurapalli.png"
                class="Tiruchurapalli2"
                alt="Tiruchurapalli"
                data-toggle="tooltip"
                data-placement="top"
                title="Tiruchirappalli"
                (click)="mapGetBtn('Tiruchirappalli')"
              />
            </div>
            <div class="hover-switch" id="Thanjavur">
              <img
                src="assets/images/new-map/blue/Thanjavur.png"
                class="Thanjavur"
                alt="Thanjavur"
              />
              <img
                src="assets/images/new-map/new_yellow/thanjavur.png"
                class="Thanjavur2"
                alt="Thanjavur"
                data-toggle="tooltip"
                data-placement="top"
                title="Thanjavur"
                (click)="mapGetBtn('Thanjavur')"
              />
            </div>
            <div class="hover-switch" id="Nilgiris">
              <img
                src="assets/images/new-map/blue/Nilgiris.png"
                class="Nilgiris"
                alt="Nilgiris"
              />
              <img
                src="assets/images/new-map/new_yellow/The Nilgiris.png"
                class="Nilgiris2"
                alt="Nilgiris"
                data-toggle="tooltip"
                data-placement="top"
                title="Nilgiris"
                (click)="mapGetBtn('Nilgiris')"
              />
            </div>
            <div class="hover-switch" id="Coimbatore">
              <img
                src="assets/images/new-map/blue/Coimbatore.png"
                class="Coimbatore"
                alt="Coimbatore"
              />
              <img
                src="assets/images/new-map/new_yellow/Coimbatore.png"
                class="Coimbatore2"
                alt="Coimbatore"
                data-toggle="tooltip"
                data-placement="top"
                title="Coimbatore"
                (click)="mapGetBtn('Coimbatore')"
              />
            </div>
            <div class="hover-switch" id="Tiruppur">
              <img
                src="assets/images/new-map/blue/Tiruppur.png"
                class="Thiruppur"
                alt="Thiruppur"
              />
              <img
                src="assets/images/new-map/new_yellow/Thiruppur.png"
                class="Thiruppur2"
                alt="Thiruppur"
                data-toggle="tooltip"
                data-placement="top"
                title="Tiruppur"
                (click)="mapGetBtn('Tiruppur')"
              />
            </div>
            <div class="hover-switch" id="Karur">
              <img
                src="assets/images/new-map/blue/Karur.png"
                class="Karur"
                alt="Karur"
              />
              <img
                src="assets/images/new-map/new_yellow/Karur.png"
                class="Karur"
                alt="Karur2"
                data-toggle="tooltip"
                data-placement="top"
                title="Karur"
                (click)="mapGetBtn('Karur')"
              />
            </div>
            <div class="hover-switch" id="Dindigul">
              <img
                src="assets/images/new-map/blue/Dindigul.png"
                class="Dindigul"
                alt="Dindigul"
              />
              <img
                src="assets/images/new-map/new_yellow/Dindigul.png"
                class="Dindigul2"
                alt="Dindigul"
                data-toggle="tooltip"
                data-placement="top"
                title="Dindigul"
                (click)="mapGetBtn('Dindigul')"
              />
            </div>
            <div class="hover-switch" id="Pudukkottai">
              <img
                src="assets/images/new-map/blue/Pudhukottai.png"
                class="Pudhukottai"
                alt="Pudhukottai"
              />
              <img
                src="assets/images/new-map/new_yellow/Pudhukottai.png"
                class="Pudhukottai2"
                alt="Pudhukottai"
                data-toggle="tooltip"
                data-placement="top"
                title="Pudukkottai"
                (click)="mapGetBtn('Pudukkottai')"
              />
            </div>
            <div class="hover-switch" id="Sivagangai">
              <img
                src="assets/images/new-map/blue/Sivagangai.png"
                class="Sivagangai"
                alt="Sivagangai"
              />
              <img
                src="assets/images/new-map/new_yellow/Sivaganga.png"
                class="Sivagangai2"
                alt="Sivagangai"
                data-toggle="tooltip"
                data-placement="top"
                title="Sivagangai"
                (click)="mapGetBtn('Sivagangai')"
              />
            </div>
            <div class="hover-switch" id="Madurai">
              <img
                src="assets/images/new-map/blue/Madurai.png"
                class="Madurai"
                alt="Madurai"
              />
              <img
                src="assets/images/new-map/new_yellow/Madurai.png"
                class="Madurai"
                alt="Madurai2"
                data-toggle="tooltip"
                data-placement="top"
                title="Madurai"
                (click)="mapGetBtn('Madurai')"
              />
            </div>
            <div class="hover-switch" id="Theni">
              <img
                src="assets/images/new-map/blue/Theni.png"
                class="Theni"
                alt="Theni"
              />
              <img
                src="assets/images/new-map/new_yellow/Theni.png"
                class="Theni2"
                alt="Theni"
                data-toggle="tooltip"
                data-placement="top"
                title="Theni"
                (click)="mapGetBtn('Theni')"
              />
            </div>
            <div class="hover-switch" id="Virudhunagar">
              <img
                src="assets/images/new-map/blue/Virudhunagar.png"
                class="Virudhunagar"
              />
              <img
                src="assets/images/new-map/new_yellow/Virudhunagar.png"
                class="Virudhunagar2"
                alt="Virudhunagar"
                data-toggle="tooltip"
                data-placement="top"
                title="Virudhunagar"
                (click)="mapGetBtn('Virudhunagar')"
              />
            </div>
            <div class="hover-switch" id="Ramanathapuram">
              <img
                src="assets/images/new-map/blue/Ramanathapuram.png"
                class="Ramanathapuram"
              />
              <img
                src="assets/images/new-map/new_yellow/Ramanathapuram.png"
                class="Ramanathapuram2"
                alt="Ramanathapuram"
                data-toggle="tooltip"
                data-placement="top"
                title="Ramanathapuram"
                (click)="mapGetBtn('Ramanathapuram')"
              />
            </div>
            <div class="hover-switch" id="Thoothukudi">
              <img
                src="assets/images/new-map/blue/Thoothukudi.png"
                class="Thoothukudi"
              />
              <img
                src="assets/images/new-map/new_yellow/Thoothukudi.png"
                class="Thoothukudi2"
                alt="Thoothukudi"
                data-toggle="tooltip"
                data-placement="top"
                title="Thoothukudi"
                (click)="mapGetBtn('Thoothukudi')"
              />
            </div>
            <div class="hover-switch" id="Tirunelveli">
              <img
                src="assets/images/new-map/blue/Tirunelveli.png"
                class="Tirunelveli"
              />
              <img
                src="assets/images/new-map/new_yellow/Tirunelveli.png"
                class="Tirunelveli2"
                alt="Tirunelveli"
                data-toggle="tooltip"
                data-placement="top"
                title="Tirunelveli"
                (click)="mapGetBtn('Tirunelveli')"
              />
            </div>
            <div class="hover-switch" id="Kanyakumari">
              <img
                src="assets/images/new-map/blue/Kanyakumari.png"
                class="Kanyakumari"
              />
              <img
                src="assets/images/new-map/new_yellow/Kanyakumari.png"
                class="Kanyakumari2"
                alt="Kanyakumari"
                data-toggle="tooltip"
                data-placement="top"
                title="Kanyakumari"
                (click)="mapGetBtn('Kanyakumari')"
              />
            </div>
            <div class="hover-switch" id="Tenkasi">
              <img
                src="assets/images/new-map/blue/Tenkasi.png"
                class="Tenkasi"
                alt="Tenkasi"
              />
              <img
                src="assets/images/new-map/new_yellow/Tenkasi.png"
                class="Tenkasi2"
                alt="Tenkasi"
                data-toggle="tooltip"
                data-placement="top"
                title="Tenkasi"
                (click)="mapGetBtn('Tenkasi')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="home-section-div">
          <div class="map-bg">
            <div class="text-center map-bgfont">
              <div
                class="text-center map-bgfont"
                *ngIf="districtValue.name === 'Startup'"
              >
                <div class="text-center">
                  <img
                    style="height: 55px"
                    src="assets/images/new_logo.png"
                    class="img-fluid about-img"
                    alt=""
                  />
                </div>
                <h4 style="color: white">Total No Of Incubators</h4>
                <h2 class="dis-users">124</h2>
              </div>
              <div
                class="text-center map-bgfont dist-user"
                *ngIf="districtValue.name !== 'Startup'"
              >
                <h2 class="map-bgfont">{{ districtValue.name }}</h2>
                <div *ngIf="districtValue.count !== 0">
                  <h4 class="" style="color: white">No. Of. Incubators</h4>
                  <h2
                    class="dis-users"
                    (click)="viewdistrict(districtValue.name)"
                  >
                    {{ districtValue.count }}
                  </h2>
                </div>

                <h4 *ngIf="districtValue.count === 0" style="color: white">
                  Onboarding Soon
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
